import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=a6b605d4"
import script from "./AccountDetail.vue?vue&type=script&lang=ts"
export * from "./AccountDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports